import {Component, OnInit} from "@angular/core";
import { environment } from "../environments/environment";

@Component({
    selector: 'central',
    template: '',
    standalone: true
})
export class CentralComponent implements OnInit{

  ngOnInit(): void {
    window.location.href = environment.centralUrl
  }

}
